import React, { Component } from 'react'
import { translate } from 'react-polyglot'
import EE from 'emitter.js'

import { Text, Icon, Button, ButtonGroup } from 'components'
import SearchEmptyStateSvg from 'assets/img/svg/search-empty-state.js'
import SearchNoResultsSvg from 'assets/img/svg/search-no-results.js'

import './results.scss'

class FusePicker extends Component {
	render() {
		const {
			isOpen,
			fuseOptions,
			items,
			selectedIndex,
			searchInput,
			t,
		} = this.props

		let inputLength = 0

		if (searchInput.current) {
			inputLength = searchInput.current.value.length
		}

		if (!isOpen) {
			return null
		}

		return (
			<div className="o-search-results">
				{items.length > 0 && (
					<Text size="small" color="light">
						{t('search_results')} ({items.length})
					</Text>
				)}

				{items.length === 0 &&
					inputLength >= fuseOptions.minMatchCharLength && (
						<div className="o-search-results__info">
							<SearchNoResultsSvg />
							<Text color="light">
								<strong>{t('no_search_results')}</strong>
							</Text>
						</div>
					)}

				{items.length === 0 &&
					inputLength < fuseOptions.minMatchCharLength && (
						<div className="o-search-results__info">
							<SearchEmptyStateSvg />
						</div>
					)}

				{items.length > 0 && (
					<ul className="o-search-results__list">
						{items.map((item, index) => (
							<li
								key={index}
								className={`o-search-results__item ${
									index === selectedIndex
										? 'is-selected'
										: 'is-not-selected'
								}`}
								onMouseOver={() =>
									this.props._selectIndex(index)
								}
								onClick={() =>
									this.props.onChange(items[index])
								}
							>
								{this.props.renderItem(item)}
							</li>
						))}
					</ul>
				)}

				{inputLength >= fuseOptions.minMatchCharLength && (
					<div className="o-search-results__suggestion">
						<h3>{t('suggestion_box_title')}</h3>
						<Text color="light">{t('suggestion_box_text')}</Text>
						<ButtonGroup>
							<Button
								onClick={() => {
									EE.emit('showSuggestionModal')
								}}
								text={t('send_suggestion')}
								icon={<Icon name="tips" />}
								size="small"
								layout="secondary"
							/>
						</ButtonGroup>
					</div>
				)}
			</div>
		)
	}
}

export default translate()(FusePicker)
